import { createStore, applyMiddleware, compose } from 'redux'
import { routerMiddleware } from 'react-router-redux'
import {createBrowserHistory} from 'history';
import {rootReducer, rootSaga} from 'modules'
import createSagaMiddleware from 'redux-saga';
import navigationController from 'navigation/navigationController';
import sessionTimemoutMiddleware from './sessionTimeoutMiddleware';

export const history = createBrowserHistory()
const sagaMiddleware = createSagaMiddleware()

const initialState = {}
const middleware = [
  sessionTimemoutMiddleware,
  navigationController,
  sagaMiddleware,
  routerMiddleware(history),
]

let composeEnhancers = compose;
const enableRedux = process.env.NODE_ENV === 'development' || !!sessionStorage.getItem('enableRedux');
if (enableRedux && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
}

const composedEnhancers = composeEnhancers(
  applyMiddleware(...middleware),
)

const store = createStore(
  rootReducer,
  initialState,
  composedEnhancers
)

sagaMiddleware.run(rootSaga);

export default store
